import { createContext, useContext } from "react";
import { Article } from "@/lib/types/Article";
import { Document } from "@/lib/types/Document";

export interface IArticleDetailContext {
  article: Article;
  documents: Document[];
}

const ArticleDetailContext = createContext<IArticleDetailContext>({} as IArticleDetailContext);

export const useArticleDetailContext = (): IArticleDetailContext => {
  const context = useContext(ArticleDetailContext);
  if (!context) {
    throw new Error("useArticleDetailContext must be used within a Context provider");
  }
  return context;
};

export default ArticleDetailContext;
